// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ac2c427d","977":"e323318d"}[chunkId] + ".chunk.js";
};